// Standby state <-> query string. Pure (URLSearchParams only).
// p=<price>&h=<hours>&<id>=<count>&<id>w=<own watt>&h_<group>=<hours>
import { DEFAULT_PRICE, usableItems } from './calc.js';

export const LIMITS = { price: [0.1, 1], hours: [1, 24], count: [0, 50], watt: [0, 500] };

const num = (raw) => {
  if (raw === null || raw === '') return NaN;
  return Number(String(raw).replace(',', '.'));
};
const inRange = (v, [a, b]) => Number.isFinite(v) && v >= a && v <= b;

export function defaults(config = {}) {
  const price = inRange(Number(config.preis), LIMITS.price) ? Number(config.preis) : DEFAULT_PRICE;
  return { price, hours: 24, counts: {}, custom: {}, groupHours: {} };
}

export function decodeState(data, query, config = {}) {
  const p = new URLSearchParams(query || '');
  const state = defaults(config);
  const price = num(p.get('p'));
  if (inRange(price, LIMITS.price)) state.price = price;
  const hours = num(p.get('h'));
  if (inRange(hours, LIMITS.hours)) state.hours = hours;
  for (const g of data.groups) {
    const gh = num(p.get('h_' + g.id));
    if (inRange(gh, LIMITS.hours)) state.groupHours[g.id] = gh;
  }
  for (const item of usableItems(data)) {
    const c = num(p.get(item.id));
    if (Number.isFinite(c) && c > 0) state.counts[item.id] = Math.min(LIMITS.count[1], Math.round(c));
    const w = num(p.get(item.id + 'w'));
    if (inRange(w, LIMITS.watt) && w > 0) state.custom[item.id] = w;
  }
  return state;
}

export function encodeState(data, state, config = {}) {
  const base = defaults(config);
  const p = new URLSearchParams();
  if (Number.isFinite(state.price) && Math.abs(state.price - base.price) > 1e-9) p.set('p', String(state.price));
  if (Number.isFinite(state.hours) && state.hours !== 24) p.set('h', String(state.hours));
  for (const g of data.groups) {
    const gh = state.groupHours?.[g.id];
    if (Number.isFinite(gh)) p.set('h_' + g.id, String(gh));
  }
  for (const item of usableItems(data)) {
    const c = state.counts?.[item.id];
    if (c > 0) p.set(item.id, String(c));
    const w = state.custom?.[item.id];
    if (Number.isFinite(w)) p.set(item.id + 'w', String(w));
  }
  return p.toString();
}
